var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2270_53478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 12.5C25 19.4036 19.4036 25 12.5 25C5.59635 25 0 19.4036 0 12.5C0 5.59635 5.59635 0 12.5 0C19.4036 0 25 5.59635 25 12.5Z",
    fill: "#0EA3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0602 23.2034C15.731 21.1763 14.3465 18.3801 14.3465 18.3801C14.3465 18.3801 9.74865 10.6537 9.12628 10.6537C5.28831 8.10735 7.50504 1.074 7.5182 1.03223C3.0941 2.95693 0 7.36749 0 12.5C0 19.0828 5.08842 24.4772 11.5467 24.9641C11.8322 24.3871 12.3028 23.7783 13.0602 23.2034Z",
    fill: "#3FB6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9627 10.6539H15.2515C14.7518 10.6539 14.3467 10.2486 14.3467 9.74885V6.03791C14.3467 5.01805 13.5201 4.19141 12.5002 4.19141C11.4805 4.19141 10.6539 5.01805 10.6539 6.03791V9.74885C10.6539 10.2486 10.2486 10.6539 9.74885 10.6539H6.03791C5.01805 10.6539 4.19141 11.4805 4.19141 12.5002C4.19141 13.5199 5.01805 14.3465 6.03791 14.3465H9.74885C10.2486 14.3465 10.6539 14.7518 10.6539 15.2516V18.9625C10.6539 19.9823 11.4805 20.809 12.5002 20.809C13.5201 20.809 14.3467 19.9823 14.3467 18.9625V15.2516C14.3467 14.7518 14.7518 14.3465 15.2515 14.3465H18.9627C19.9823 14.3465 20.809 13.5199 20.809 12.5002C20.809 11.4805 19.9823 10.6539 18.9627 10.6539Z",
    fill: "white",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2270_53478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueAdd);
export default __webpack_public_path__ + "static/media/blue-add.a60c849c2e2219912378b77ec5dcb15c.svg";
export { ForwardRef as ReactComponent };